import api from "services/api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_USER_ACCESS_TIMES = API_URL_VERSION + "horarios-acesso";
export const ENDPOINT_USER_ACCESS_TIMES_LIST = ENDPOINT_USER_ACCESS_TIMES + "/listar";

export const daysOfWeek = [
  { value: "1", label: "sunday" },
  { value: "2", label: "monday" },
  { value: "3", label: "tuesday" },
  { value: "4", label: "wednesday" },
  { value: "5", label: "thursday" },
  { value: "6", label: "friday" },
  { value: "7", label: "saturday" }
];

export const userAccessTimesService = {
  list: async (params) => {
    try {
      const response = await api.post(ENDPOINT_USER_ACCESS_TIMES_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user-access-times.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_USER_ACCESS_TIMES, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user-access-times.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_USER_ACCESS_TIMES}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user-access-times.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_USER_ACCESS_TIMES}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user-access-times.messages.errors.update";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_USER_ACCESS_TIMES}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user-access-times.messages.errors.delete";
    }
  },
};
